module.exports = {
	"spreadsheetId": "3",
	"properties": {
		"title": "Version 2 Test Schedule"
	},
	"sheets": [
		{
			"properties": {
				"sheetId": 293666632,
				"title": "School",
				"index": 0,
				"sheetType": "GRID",
				"gridProperties": {
					"rowCount": 290,
					"columnCount": 12,
					"frozenRowCount": 1
				}
			},
			"data": [
				{
					"rowData": [
						{
							"values": [
								{
									"formattedValue": "name"
								},
								{
									"formattedValue": "meeting_type_id"
								},
								{
									"formattedValue": "start_time"
								},
								{
									"formattedValue": "end_time"
								},
								{
									"formattedValue": "day_of_week"
								},
								{
									"formattedValue": "teacher_id"
								},
								{
									"formattedValue": "teacher_id"
								},
								{
									"formattedValue": "section_id"
								},
								{
									"formattedValue": "section_id"
								},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Dance"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "W"
								},
								{
									"formattedValue": "Dance, 1A"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "M, T,Th,F"
								},
								{
									"formattedValue": "PE"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1:00"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1B"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math Corner"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "1:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1B"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "9:30"
								},
								{
									"formattedValue": "10:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1A"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Science"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "2:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1B"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "8:50"
								},
								{
									"formattedValue": "9:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "Ranting"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "SS"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2:30"
								},
								{
									"formattedValue": "3:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1B"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "SS"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:00"
								},
								{
									"formattedValue": "8:50"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1A"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "WW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "10:30"
								},
								{
									"formattedValue": "11:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1A"
								},
								{},
								{
									"formattedValue": "1A"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Lunch 2"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "11:30"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "M-F"
								},
								{},
								{},
								{
									"formattedValue": "1A, 1B, 1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Recess"
								},
								{
									"formattedValue": "Recess"
								},
								{
									"formattedValue": "11:10"
								},
								{
									"formattedValue": "11:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1A, 1B"
								},
								{},
								{
									"formattedValue": "1A, 1B, 1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Dance"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "T"
								},
								{
									"formattedValue": "Dance, 1B"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "M,W,Th,F"
								},
								{
									"formattedValue": "PE"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "10:30"
								},
								{
									"formattedValue": "11:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1B"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math Corner"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "9:30"
								},
								{
									"formattedValue": "10:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1B"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1:00"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1A"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Science"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:00"
								},
								{
									"formattedValue": "8:50"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1B"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "8:50"
								},
								{
									"formattedValue": "9:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "Quilting"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "SS"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "1:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1A"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "WW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "3:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1A"
								},
								{},
								{
									"formattedValue": "1B"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Dance"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "Th"
								},
								{
									"formattedValue": "Dance, 1C"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "M,T,W,F"
								},
								{
									"formattedValue": "PE"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1:00"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1C"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math Corner"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "12:40"
								},
								{
									"formattedValue": "1:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1C"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "10:30"
								},
								{
									"formattedValue": "11:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1C"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Science"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:00"
								},
								{
									"formattedValue": "8:50"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1C"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "8:50"
								},
								{
									"formattedValue": "9:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "Pyrotechnics"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "SS"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "9:30"
								},
								{
									"formattedValue": "10:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1C"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "WW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "3:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "1C"
								},
								{},
								{
									"formattedValue": "1C"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Dance"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "W"
								},
								{
									"formattedValue": "Dance, KA"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "M, T,Th,F"
								},
								{
									"formattedValue": "PE"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:30"
								},
								{
									"formattedValue": "9:40"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KA"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math Corner"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:00"
								},
								{
									"formattedValue": "8:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KA"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "9:40"
								},
								{
									"formattedValue": "10:15"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KA"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "10:15"
								},
								{
									"formattedValue": "10:50"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KA"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Science"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "1:10"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KA"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "SS"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1:10"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KA"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "WW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "3:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KA"
								},
								{},
								{
									"formattedValue": "KA"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Lunch 1"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "12:50"
								},
								{
									"formattedValue": "M-F"
								},
								{},
								{},
								{
									"formattedValue": "KA, KB, KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Recess"
								},
								{
									"formattedValue": "Recess"
								},
								{
									"formattedValue": "11:50"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KA, KB"
								},
								{},
								{
									"formattedValue": "KA, KB, KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Dance"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "T"
								},
								{
									"formattedValue": "Dance, KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "M,W,Th,F"
								},
								{
									"formattedValue": "PE"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:30"
								},
								{
									"formattedValue": "9:40"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math Corner"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:00"
								},
								{
									"formattedValue": "8:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "9:40"
								},
								{
									"formattedValue": "10:15"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "10:50"
								},
								{
									"formattedValue": "11:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Science"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "1:10"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "SS"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1:10"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "WW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "3:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Dance"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "Th"
								},
								{
									"formattedValue": "Dance, KC"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "M,T,W,F"
								},
								{
									"formattedValue": "PE"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:30"
								},
								{
									"formattedValue": "9:40"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KC"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Math Corner"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "8:00"
								},
								{
									"formattedValue": "8:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KC"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "10:15"
								},
								{
									"formattedValue": "10:50"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KC"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "RW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "10:50"
								},
								{
									"formattedValue": "11:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KC"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Science"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "12:10"
								},
								{
									"formattedValue": "1:10"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KC"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "SS"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1:10"
								},
								{
									"formattedValue": "1:30"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KC"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "WW"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2:00"
								},
								{
									"formattedValue": "3:00"
								},
								{
									"formattedValue": "M-F"
								},
								{
									"formattedValue": "KC"
								},
								{},
								{
									"formattedValue": "KC"
								},
								{},
								{},
								{},
								{}
							]
						}
					]
				}
			]
		},
		{
			"properties": {
				"sheetId": 1558634518,
				"title": "Staff",
				"index": 1,
				"sheetType": "GRID",
				"gridProperties": {
					"rowCount": 935,
					"columnCount": 29
				}
			},
			"data": [
				{
					"rowData": [
						{
							"values": [
								{
									"formattedValue": "id"
								},
								{
									"formattedValue": "last_name"
								},
								{
									"formattedValue": "first_name"
								},
								{
									"formattedValue": "role"
								},
								{
									"formattedValue": "group"
								},
								{
									"formattedValue": "group_id"
								},
								{
									"formattedValue": "tags"
								},
								{
									"formattedValue": "fte"
								},
								{
									"formattedValue": "prep_teachers"
								},
								{
									"formattedValue": "release_teachers"
								},
								{
									"formattedValue": "unavailable"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Alexander"
								},
								{
									"formattedValue": "Abe"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Buttons"
								},
								{
									"formattedValue": "Bran"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Calmface"
								},
								{
									"formattedValue": "Carter"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Dustwhisper"
								},
								{
									"formattedValue": "Deanna"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Eddings"
								},
								{
									"formattedValue": "Ernora"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Fastcharge"
								},
								{
									"formattedValue": "Fron"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Ranting"
								},
								{
									"formattedValue": "Heckchance"
								},
								{
									"formattedValue": "Holda"
								},
								{
									"formattedValue": "Ranting"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "2"
								},
								{},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Quilting"
								},
								{
									"formattedValue": "Idlebrain"
								},
								{
									"formattedValue": "Ice"
								},
								{
									"formattedValue": "Quilting"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "2"
								},
								{
									"formattedValue": "Coach"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Pyrotechnics"
								},
								{
									"formattedValue": "Johnpepto"
								},
								{
									"formattedValue": "Jarga"
								},
								{
									"formattedValue": "Pyrotechnics"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "2"
								},
								{},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Dance"
								},
								{
									"formattedValue": "Kidsquisher"
								},
								{
									"formattedValue": "Kitten"
								},
								{
									"formattedValue": "Dance"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "2"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Lamp"
								},
								{
									"formattedValue": "Lauren"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "2"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						}
					]
				}
			]
		},
		{
			"properties": {
				"sheetId": 214155908,
				"title": "Cohorts",
				"index": 2,
				"sheetType": "GRID",
				"gridProperties": {
					"rowCount": 973,
					"columnCount": 27
				}
			},
			"data": [
				{
					"rowData": [
						{
							"values": [
								{
									"formattedValue": "id"
								},
								{
									"formattedValue": "name"
								},
								{
									"formattedValue": "group"
								},
								{
									"formattedValue": "group_id"
								},
								{
									"formattedValue": "tags"
								},
								{
									"formattedValue": "Size"
								},
								{
									"formattedValue": "%ELL"
								},
								{
									"formattedValue": "%ISE"
								},
								{
									"formattedValue": "%FRL"
								},
								{
									"formattedValue": "%Female"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1C"
								}
							]
						}
					]
				}
			]
		},
		{
			"properties": {
				"sheetId": 1120187879,
				"title": "Meetings",
				"index": 3,
				"sheetType": "GRID",
				"gridProperties": {
					"rowCount": 988,
					"columnCount": 26
				}
			},
			"data": [
				{
					"rowData": [
						{
							"values": [
								{
									"formattedValue": "id"
								},
								{
									"formattedValue": "name"
								},
								{
									"formattedValue": "type"
								},
								{
									"formattedValue": "core"
								},
								{
									"formattedValue": "instructional"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Recess"
								},
								{
									"formattedValue": "Recess"
								},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						}
					]
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/clients/mock/fixtures/sheets/3.json
 ** module id = 300
 ** module chunks = 0
 **/